import { HttpInterceptorFn } from "@angular/common/http";
import { inject, Injector } from "@angular/core";
import { KeycloakService } from "../services/keycloak.service";
import { environment } from "../../environments/environment";
import { isExternalUrl } from "../utils/request";
import { toObservable } from "@angular/core/rxjs-interop";
import { filter, switchMap, take } from "rxjs";

export const providerInterceptor: HttpInterceptorFn = (req, next) => {
    const keycloakService = inject(KeycloakService);

    if (environment.keycloak.enabled === false || isExternalUrl(req.url)) {
        return next(req);
    }

    // On attend que Keycloak soit prêt avant de laisser passer la requête
    return toObservable(keycloakService.isInitialized, { injector: inject(Injector) }).pipe(
        filter(ready => ready === true),
        take(1),
        switchMap(() => {
            if (!keycloakService.isAuthenticated()) {
                return next(req);
            }

            const email = keycloakService.getUserEmail();

            if (!email) {
                return next(req);
            }

            return next(req.clone({
                setParams: { email }
            }));
        })
    );
};